export default __webpack_public_path__ + "static/media/bootstrap-4.3e07f9fd.svg";